import {
  ClientQueryParams,
  GetClientApiResponse,
  IGetClientsResponse,
} from '../../api/types/client.type';
import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {
  deleteClient,
  getClients,
  Loadentity as getLoadEntityData,
  addEntity,
  getClientData,
} from '../../api/endpoints/clientsApi';
import {
  LoadEntityResponseParams,
  EntityRequestParams,
} from '../../api/types/client.type';

interface UseClientsParams {
  EntityLabel?: string;
  EntityTypeID?: string;
  PageNumber?: number;
  PageSize?: number;
  SortingColumn?: string;
  SortingOrder?: string;
}

export const useClients = (params: UseClientsParams) => {
  return useQuery<IGetClientsResponse, Error>({
    queryKey: ['clients', params],
    queryFn: () => getClients(params),
    retry: 2,
  });
};

export const useDeleteClient = (onError?: (err: Error) => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (entityId: number) => deleteClient(entityId),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['clients']});
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetLoadEntityData = (key: string) => {
  return useQuery<LoadEntityResponseParams, Error>({
    queryKey: ['loadEntityData', key],
    queryFn: () =>
      getLoadEntityData({
        defautlICEInstaceID: 0,
        defaultDBSizeID: '',
        clientDefaultDatabaseSizeCode: '',
        domainDefaultDatabaseSizeCode: '',
      }),
    enabled: !!key,
    retry: 2,
  });
};

export const useGetAddEntityData = (onError?: (err: Error) => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: EntityRequestParams) => addEntity(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['clients']});
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetClientData = (
  queryParams: ClientQueryParams,
  enabled = false
) => {
  return useQuery<GetClientApiResponse, Error>({
    queryKey: ['ClientData', queryParams.entityId],
    queryFn: async () => {
      return getClientData(queryParams);
    },
    retry: 2,
    enabled,
  });
};
